import React from 'react'

// CSS styles
import './styles.css'

function Data() {

    return (
        <div className="Data">
            <textarea required placeholder="Type or paste data here..."></textarea>
        </div>
    )
}

export default Data